import { useMemo } from 'react';
import { IDisplayedMeasure, IDisplayedMeasureSetting } from '../interfaces';
import {
  IMeasureDisplayFormatFieldsFragment,
  Maybe,
  MeasureDisplayFormatKind,
} from '../../../utils/apollo/graphqlSchema';
import { defaultMeasureDisplayFormat } from '../../../utils/builder/measures/utils';

interface IProps {
  forcePercent?: boolean;
  displayedMeasures?: IDisplayedMeasure[];
}

const getChartFormatFromVisibleMeasure = (
  displayedMeasureSettings: IDisplayedMeasureSetting[],
): Maybe<IMeasureDisplayFormatFieldsFragment> => {
  const visibleMeasureCount = displayedMeasureSettings.filter(
    (measure) => measure.isVisible,
  ).length;
  // if there are visible measures, return the first visible measure format.
  if (visibleMeasureCount >= 1) {
    const visibleMeasure = displayedMeasureSettings.find(
      (measure) => measure.isVisible,
    );
    if (visibleMeasure) {
      return visibleMeasure.format;
    }
  }

  return null;
};

const useYAxisFormat = ({
  forcePercent = false,
  displayedMeasures,
}: IProps): Maybe<IMeasureDisplayFormatFieldsFragment> =>
  useMemo(() => {
    const defaultResult: IMeasureDisplayFormatFieldsFragment = {
      ...defaultMeasureDisplayFormat,
      kind: forcePercent
        ? MeasureDisplayFormatKind.Percent
        : MeasureDisplayFormatKind.Number,
      decimalPlace: 0,
    };

    if (!displayedMeasures?.length) {
      return defaultResult;
    }

    const format = getChartFormatFromVisibleMeasure(displayedMeasures);

    return format || defaultResult;
  }, [displayedMeasures, forcePercent]);

export default useYAxisFormat;
